import $ from 'jquery';
import React, {ElementType} from 'react';

import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';

export function renderReactElement(element: JSX.Element): void {
  const $mount = $('.react-mount');
  if ($mount.length !== 1) {
    const count = $mount.length === 0 ? 'no' : 'multiple';
    throw new Error(`Cannot render React component - ${count} .react-mount found`);
  }
  ReduxDOMRender.renderToDOM(element, $mount[0]);
}

export function renderReactComponent(Component: ElementType, componentProps: object = {}): void {
  renderReactElement(
    <Component {...componentProps} {...(window.bootstrap && window.bootstrap.componentProps)} />
  );
}
